import axios from './axios';

const API_URL = '/C4-Nicaragua/UnidadMedidas'; // ajusta si usas otro endpoint


export const getUnidadesMedidas = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener unidades:', error);
    return [];
  }
};

export const addUnidadMedida= async (unidades) => {
  try {
    //console.log(API_URL);

    const response = await axios.post(API_URL, unidades);
    return response.data;
  } catch (error) {
    //console.error('Error al guardar cliente 1', error);
    throw error;
  }
};

export const updateUnidadMedida = async (id, unidades) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, unidades);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar unidades', error);
    throw error;
  }
};

export const eliminarUnidadMedida  = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar unidades', error);
    throw error;
  }
};

export const  getNumeroNexUnidadMedida= async()  =>
{
    try{
    const response = await axios.get(`${API_URL}/NextNoUnidad`);
    return response.data;    
    }
    catch(error)
    {
      console.error('Error al obtener el numero del siguiente unidad', error);
      throw error;
    }
}

export const searchMedidas =async(medida) =>
{
  try{//
    //router.get('/productos/buscar', buscarProductos);
   //
    console.log(medida);
    console.log(`${API_URL}/TipoUnidadMedida/buscar`);
    const response = await axios.get(`${API_URL}/TipoUnidadMedida/buscar`, {
      params: { search: medida }   // 👈 aquí va el query
    });
   
    console.log(response);
    return response.data;
  }
  catch(error)
  {
    console.error('Error al buscar tipo de medida:', error);
    //res.status(500).json({ mensaje: 'Error al buscar tipo de medida:' });
     throw error;
  }
}

